import { scrollbarTheme } from '../../../assets/customThemes/scrollbarTheme';

export const style = {
    list:{
        backgroundColor: '#FFF',
        paddingBottom: '20px',
        overflowY: 'auto',
        overflowX: 'hidden',
        ...scrollbarTheme
    },
    icon: {
        height: '22px',
        width: '22px',
        background: 'none',
        margin: 0,
        transition: 'transform 0.2s ease',
    },
    iconOff: {
        height: '22px',
        width: '22px',
        background: 'none',
        margin: 0,
        filter:'grayscale(1) opacity(0.5)',
    },
    listItemText: {
        fontSize: '13px',
        fontWeight: 500,
        letterSpacing: '0.01em',
    },
    listItemButton: {
        padding: '4px 8px',
        justifyContent: 'space-between',
        display:'flex',
        borderRadius: '12px',
        margin: '2px 8px',
        transition: 'all 0.2s ease',
        '&:hover': {
            backgroundColor: 'rgba(112, 33, 128, 0.06)',
        }
    },
    listItemRow: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignContent: 'center',
        alignItems: 'center',
        justifyContent: 'start',
        padding: '12px 14px',
        transition: 'all 0.2s ease',
    },
    mobileArea: {
        display: 'none',
        '@media (max-width: 600px)': {
            display: 'flex',
            justifyContent: 'space-between',
            alignContent: 'center',
            alignItems: 'center',
            width: '100wv',
          }
    },
    mobileTitle: {
        margin: 0,
        padding: 0,
    },
    iconHamburguer:{
        height: '20px',
        marginLeft:'14px'
    },
    iconHistoric:{
        height: '30px',
        marginRight:'14px'
    },
    upgradeButton:{
        height:'32px',
        marginRight: '10px',
        backgroundColor: '#702180',
        textTransform: 'none',
        borderRadius: '20px',
        fontWeight: 600,
        fontSize: '13px',
        boxShadow: '0 2px 8px rgba(112, 33, 128, 0.25)',
        ':hover':{
            backgroundColor: '#5a1a66',
            boxShadow: '0 4px 12px rgba(112, 33, 128, 0.35)',
        },
    },
    imageButton:{
        height:'32px',
        marginRight: '10px',
        backgroundColor: '#00a271',
        textTransform: 'none',
        borderRadius: '20px',
        fontWeight: 600,
        fontSize: '13px',
        boxShadow: '0 2px 8px rgba(0, 162, 113, 0.25)',
        ':hover':{
            backgroundColor: '#008f63',
            boxShadow: '0 4px 12px rgba(0, 162, 113, 0.35)',
        }   
    },
    iconCrown: {
        height: '12px',
        width: '12px',
        position: 'absolute',
        top: '-6px',
        right: '-6px',
    },
}
